export default __webpack_public_path__ + "ec1d6395e48a94362a7d5dae896f63b1.png";